import { isArray } from 'lodash'
import * as services from '../../app/auth/services.js'
import { setToken } from './index.js'
import { appUrl } from '../../config'

export default (http, store, router) => {

    // Add a request interceptor
    http.interceptors.request.use(
        config => {

            if (! config.hideLoader ) {
                // Show loader
                $('.pace').removeClass('pace-inactive');
                $('.pace').addClass('pace-active');
            }

            store.dispatch('setFetching', { fetching: true })

            // Do something before request is sent
            return config;
        },
        (error) => {

            // Do something with request error
            return Promise.reject(error);
        }
    ),

    // https://github.com/mzabriskie/axios#interceptors
    http.interceptors.response.use(

        response => {
            if (! response.config.hideLoader ) {
                // Remove loader
                $('.pace').removeClass('pace-active');
                $('.pace').addClass('pace-inactive');
            }

            store.dispatch('setFetching', { fetching: false })

            return response
        },

        /**
        * This is a central point to handle all
        * error messages generated by HTTP
        * requests
        */
        (error) => {

            if (! error.config.hideLoader ) {
                // Remove loader
                $('.pace').removeClass('pace-active');
                $('.pace').addClass('pace-inactive');
            }

            const { response } = error

            /**
            * If token is either expired, not provided or invalid
            * then redirect to login. On server side the error
            * messages can be changed on app/Providers/EventServiceProvider.php
            */
            if (response.status == 401) {

               // store.dispatch('setToken', null)
                //store.dispatch('setUser', {})
                
                //window.location = appUrl+'/logout';
                router.push({ name: 'lms.login' })
            }

            store.dispatch('resetMessages')

            /**
            * Error messages are sent in arrays
            */
            if (response.data.errors && typeof response.data.errors === 'object') {
                store.dispatch('setMessage', { type: 'error', message: response.data.errors })
            } else {
                if (response.data.message) {
                    store.dispatch('setMessage', { type: 'warning', message: response.data.message })
                }
            }



            /**
             * Laravel generated validation errors are
             * sent in an object
             */
            // if (response.data.message) {
            //     store.dispatch('setMessage', { type: 'validation', message: response.data.message })
            // }

            store.dispatch('setFetching', { fetching: false })

            return Promise.reject(error)
        }
    )
}



// WEBPACK FOOTER //
// ./src/plugins/http/interceptors.js